import { useEffect, useState } from 'react'
import { mapState } from '../../store/mapStore'

// Right-click context menu on empty map (no drawing tool active — those use
// right-click for erase/delete). Returns the menu position + lngLat, or null.
export function useContextMenu(map) {
  const [menu, setMenu] = useState(null)

  useEffect(() => {
    if (!map.current) return
    const onContext = (e) => {
      const s = mapState()
      // Leave right-click to the active tool's own handlers.
      if (s.planModeActive || s.constructionModeActive || s.infrastructureModeActive
        || s.rulerModeActive || s.milPlanToolActive) return
      e.preventDefault()
      setMenu({ x: e.point.x, y: e.point.y, lng: e.lngLat.lng, lat: e.lngLat.lat })
    }
    const close = () => setMenu(null)
    map.current.on('contextmenu', onContext)
    map.current.on('movestart', close)
    map.current.on('click', close)
    return () => {
      map.current?.off('contextmenu', onContext)
      map.current?.off('movestart', close)
      map.current?.off('click', close)
    }
  }, [map])

  return { menu, closeMenu: () => setMenu(null) }
}
